/**
 * Created by koqiui on 2017-04-09.
 */
import { Vue, MsgBox } from '../../app.vues'
//
import SwbSkuListForSelect from './SkuListForSelect';
Vue.regist(SwbSkuListForSelect);
//
export function openSkuListSelectDlg(checkBox, filter, skuIds, callback) {
    Vue.$showDialog({
        title: '商品信息',
        width: -400,
        height: 800,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-sku-list-for-select :checkBox = "checkBox" :filter = "filter" :skuIds="skuIds" ref="swb_sku_list_for_select"></swb-sku-list-for-select>' +
        '</div>',
        data: {
            filter: [],
            checkBox: null,
            skuIds: false
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_sku_list_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                let skuInfo = result.data;
                callback(skuInfo);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
                this.filter = filter || null;
                this.checkBox = checkBox || false;
                this.skuIds = skuIds || null;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/goods/selectDlg.js
// module id = 106
// module chunks = 0